const state = {
  currentActive: null
}
const mutations = {
  changeCurrentActive: (state, v) => {
    state.currentActive = v;
  }
}
const actions = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/center.js